import CollapsibleContent from './CollapsibleContent';

export default CollapsibleContent;
